import axios from "axios";  
import { BASE_URL } from "../../assets/constants";
import { createFormHeaders, createHeaders } from "../../utils/Utils";

//! TelecallerUser APIs
export const helpSupportList = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}help-support-list`,   data,  headers);
};
export const replySupport = async (data) => {
  const headers = createHeaders()   
  return await axios.post(`${BASE_URL}reply-support`,   data,  headers);
};